import { JourneyRoute } from '@cash-web/shared-journey-data-access-context'

export const cashJourneyRoutes = [
  {
    id: 'cash-out',
    trackingName: 'Cash Out',
    path: 'cash-out',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOut')).JourneyCashOut,
    }),
  },
  {
    id: 'add-cash',
    trackingName: 'Add Cash',
    path: 'add-cash',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCash')).JourneyAddCash,
    }),
  },
] as const satisfies JourneyRoute[]
